import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { notificationCountSelector, listStateSelector, isLoadedStateSelector } from './data-access/notification.selectors';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent implements OnInit {
  notifications$: Observable<number>;
  notificationList$: Observable<any>;
  activeTabIndex: number = 0;
  isLoading$: Observable<boolean>;
  @Input() openCompanyInformation;;
  @Input() currentYear: number;

  constructor(public activeModal: NgbActiveModal, private router: Router, private store: Store) {}
  ngOnInit() {
    this.notifications$ = this.store.select(notificationCountSelector);
    this.notificationList$ = this.store.select(listStateSelector);
    this.isLoading$ = this.store.select(isLoadedStateSelector);
  
    this.notificationList$.subscribe((notifications) => {
      if (notifications.approval_pending?.length > 0) {
        this.activeTabIndex = 0;
      } else if (notifications.submission_pending?.length > 0) {
        this.activeTabIndex = 1;
      } else if (notifications.validation_pending?.length > 0) {
        this.activeTabIndex = 2;
      } else {
        this.activeTabIndex = 0;
      }
    });
  }

  openPRF() {
    this.activeModal.close();
  }
} 
